import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingTitle = ({
  title
}) => {
  return /*#__PURE__*/_jsx(AnimatedStepBody, {
    children: /*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: title
      })
    })
  }, title);
};